import {fixedHeaderHeight} from '../../../utility/js/utils';

(function () {
    var isMobile = false; // variable use to determine if responsive mode is on or off

    var sticko = {
        $parent: $('body'),
        $elements: '',
        $element: '',
        $child: '',
        pOffset: '',
        pWidth: '',
        eTop: 'auto',
        startPoint: '',
        newHeight: 0,
        marginTopVal: 0,
        marginBottomVal: 0,
        vPort: 'screen-sm',
        originalHeight: '',
        forceDisableMobileSticky: false,
        stopOn: 'never', // Define an element to stop sticky on, 'never' is the default value
        scrollHandler: null,
        stickoOnLargeHight: false,

        init: function () {
            sticko.control();
            sticko.launch();
            sticko.ctrl.check();
        },

        launch: function () {
            sticko.$elements = $('.sticko, .sticko__md'); // get sticky elements
            if (isMobile && sticko.$element.length) {
                sticko.$elements.each(function () {
                    $(this).attr('style', '');
                    if (sticko.forceDisableMobileSticky) {
                        $(this).find('.sticko__child').attr('style', '');
                    }
                    if ($(this).hasClass('sticko__md')) {
                        $(this).removeClass('js--sticko');
                    }
                });
                return;
            }
            sticko.$elements.each(function () {
                //go over sticky elements
                sticko.$element = $(this); // get current element
                if (sticko.$element.hasClass('sticko__md') && isMobile) {
                    // check if we are in responsive view port and we have responsive element
                    return; // skip responsive sticky element
                }

                if (sticko.$element.closest('.sticko__parent').length) {
                    // get parent element if exist
                    sticko.$parent = sticko.$element.closest('.sticko__parent');
                } else {
                    sticko.$parent = $('body'); // set body as prent element if parent element doesn't exist
                }

                if (sticko.$element.find('.sticko__child').length) {
                    sticko.$child = sticko.$element.find('.sticko__child');
                }

                if (sticko.destroyOnLargeHight()) return;

                sticko.$element.addClass('js--sticko'); // add class that make elements stikcy

                if (sticko.$element.is('[data-stop-on]')) {
                    // get stopOn element if exist
                    sticko.stopOn = sticko.$element.data('stop-on');
                    if ($(sticko.stopOn).length === 0) sticko.stopOn = 'never';
                } else {
                    sticko.stopOn = 'never';
                }

                sticko.define(); // get parents offsets and apply those dimensions
                if (sticko.$child.length) {
                    sticko.get.height();
                }
                sticko.ads();

                if (sticko.$element.length && sticko.$child.length) {
                    // check if we have sticko element and it has sticko child
                    const val = 0;
                    sticko.originalHeight = sticko.newHeight;
                    sticko.set.height(val, sticko.originalHeight);
                }

                sticko.additionalLaunch();
            });
        },
        control: function () {
            $(document).on(sticko.vPort + '-on', function () {
                // Waiting for custom event that will be triggered by controller.js to activate responsive effects
                isMobile = true;
            });

            $(document).on(sticko.vPort + '-off', function () {
                // Waiting for custom event that will be triggered by controller.js to deactivate responsive effects
                isMobile = false;
            });

            $(document).on('smartResize', function () {
                // Waiting for custom event that will be triggered by controller.js to deactivate responsive effects
                var hHeight = sticko.get.fixedpageElementsHeight();

                if ($(window).scrollTop() + hHeight >= $('.dynamic-sticko').offset().top) {
                    sticko.$elements.each(function () {
                        sticko.$element = $(this); // get current element
                        sticko.$parent = sticko.$element.closest('.sticko__parent') || $('body');
                        sticko.$child = sticko.$element.find('.sticko__child');
                        sticko.pWidth = sticko.$parent.width();

                        if (sticko.destroyOnLargeHight()) return;

                        const styles = {
                            width: sticko.pWidth,
                            top: hHeight + 10, // modify the element top
                        };
                        sticko.apply(sticko.$element, styles);
                    });
                }
            });
        },
        additionalLaunch: function () {},
        define: function () {
            sticko.pOffset = sticko.$parent.offset(); // get parent offset
            sticko.pLeft = sticko.pOffset.left + parseInt(sticko.$parent.css('padding-left')); // get prent's left offset
            sticko.pWidth = sticko.$parent.width(); // get parent width

            const styles = {
                width: sticko.pWidth, // store prent width to  be added to sticky element styles
                top: sticko.$element.css('top'), // modify the element top
            };
            sticko.apply(sticko.$element, styles); // apply styles after extraction from parent element
        },
        apply: function (element, styles) {
            // apply styles after extraction from parent element
            element.css(styles);
        },
        ads: function () {},
        get: {
            height: function () {
                sticko.pOffset = sticko.$parent.offset(); // get parent offset

                sticko.pWidth = sticko.$parent.width(); // get parent width

                let childHeight = 0;
                sticko.$element.children(':not(.sticko__child)').each(function () {
                    // get elements height (except sticko child)
                    childHeight += $(this).outerHeight();
                });
                sticko.newHeight = $(window).outerHeight() - (childHeight + sticko.pOffset.top);

                if ($('body').outerHeight() <= $(window).outerHeight()) {
                    sticko.newHeight = sticko.newHeight - $('.page-footer').outerHeight();
                }

                const styles = {
                    width: sticko.pWidth,
                    height: sticko.newHeight,
                    'overflow-y': 'auto',
                };
                sticko.apply(sticko.$child, styles);
            },
            fixedpageElementsHeight: function () {
                var elementsHeight = fixedHeaderHeight();

                $('.fixed-element')
                    .not('article .fixed-element')
                    .each(function (index) {
                        elementsHeight += $(this).outerHeight();
                    });

                return elementsHeight;
            },
        },
        set: {
            height: function (val, originalHeight) {
                // get new height
                let setHeightVal;
                if (sticko.$element.is('[data-stop-on]')) {
                    // get stopOn element if exist
                    sticko.stopOn = sticko.$element.data('stop-on');
                    if ($(sticko.stopOn).length === 0) sticko.stopOn = 'never';
                } else {
                    sticko.stopOn = 'never';
                }

                const offsetYTop = window.pageYOffset, // get windows y-top offset
                    offsetBottom = offsetYTop + $(window).outerHeight(), // get windows y-bottom offset
                    tabsHeight = sticko.set.variables(),
                    outOfFixedArea =
                        sticko.stopOn === 'never'
                            ? $(document).outerHeight() - $('footer').offset().top
                            : $(document).outerHeight() - $(sticko.stopOn).offset().top,
                    fixedArea =
                        outOfFixedArea === $(document).outerHeight()
                            ? $(document).outerHeight()
                            : $(document).outerHeight() - outOfFixedArea - tabsHeight; // get break point for stickiness

                sticko.pWidth = sticko.$parent.width(); // get parent width

                const styles = {
                    width: sticko.pWidth, // define styles variable
                };

                if (offsetBottom >= fixedArea) {
                    // check of we reached break point
                    val = offsetBottom - fixedArea; // get new height
                    sticko.newHeight = originalHeight - val - sticko.marginTopVal - sticko.marginBottomVal;
                    styles.height = sticko.newHeight; // store new height
                } else {
                    styles.height = originalHeight - sticko.marginTopVal - sticko.marginBottomVal; // reset original height
                }
                sticko.apply(sticko.$child, styles); // apply new height
                const hHeight = sticko.get.fixedpageElementsHeight();

                if ($('.article-row-left').outerHeight() < $(window).outerHeight()) {
                    if (!UX.accordion.isStickyBody) {
                        $('.article-row-left').height($(window).outerHeight() - hHeight);
                    }
                }
                let footerHeight = 0;
                if ($('footer').length) {
                    footerHeight = $('footer').height();
                }
                if (
                    !UX.accordion.isStickyBody &&
                    $('.sticko__side-content').outerHeight() < $(window).outerHeight() - hHeight - footerHeight
                ) {
                    $('.sticko__side-content').height($(window).outerHeight() - hHeight - footerHeight);
                }

                if (sticko.$element.hasClass('dynamic-sticko')) {
                    let dynamicStickyElement = sticko.$parent,
                        initialTop = dynamicStickyElement.offset().top - $(window).scrollTop(),
                        dynamicScrollTop = $(window).scrollTop() + hHeight,
                        dynamicHeight = $(window).outerHeight() - hHeight;

                    dynamicStickyElement.css({
                        position: 'static',
                        top: initialTop,
                    });

                    if (dynamicStickyElement.find('.tab__nav').length) {
                        dynamicHeight -= dynamicStickyElement.find('.tab__nav').outerHeight();
                    }

                    if (offsetBottom >= fixedArea) {
                        // check of we reached break point
                        val = offsetBottom - fixedArea;
                        setHeightVal = dynamicHeight - val - sticko.marginTopVal - sticko.marginBottomVal;
                    } else {
                        setHeightVal = dynamicHeight - sticko.marginTopVal - sticko.marginBottomVal;
                    }

                    if (sticko.stopOn !== 'never') setHeightVal = 'auto';

                    dynamicStickyElement.css('height', setHeightVal);
                    dynamicStickyElement.find('.sticko__child').css('height', setHeightVal);

                    const dynamicOffsetBottom =
                        dynamicScrollTop + dynamicStickyElement.outerHeight() + sticko.marginTopVal;

                    if (dynamicScrollTop + sticko.marginTopVal >= dynamicStickyElement.offset().top) {
                        let topVal = hHeight;

                        if (sticko.stopOn !== 'never' && dynamicOffsetBottom >= fixedArea)
                            topVal -= dynamicOffsetBottom - fixedArea;

                        dynamicStickyElement.css({
                            position: 'sticky',
                            top: topVal + sticko.marginTopVal,
                        });
                    }
                }
            },
            variables: function () {
                var extraMargin = 0;
                return extraMargin;
            },
        },
        ctrl: {
            check: function () {
                //check certain for action
                $(window).on('resized', function () {
                    sticko.ctrl.resize();
                });
            },
            resize: function () {
                sticko.launch();
            },
            scrolla: function () {
                // get the new height of sticko child when scroll to avoid overlaping the footer region
                if (!sticko.scrollHandler) {
                    const val = 0;
                    sticko.scrollHandler = $(window).scroll(function () {
                        if (!(isMobile && sticko.forceDisableMobileSticky)) {
                            sticko.$elements.each(function () {
                                sticko.$element = $(this); // get current element
                                sticko.$parent = sticko.$element.closest('.sticko__parent') || $('body');
                                sticko.$child = sticko.$element.find('.sticko__child');

                                // if (sticko.destroyOnLargeHight())
                                //     return;

                                sticko.set.height(val, sticko.originalHeight);
                            });
                        }
                    });
                }
            },
        },
        destroyOnLargeHight: function () {
            // destroy the sticko in case the screen height (sticko main container height) is smaller than the sticko element added for ACM ticket LIT-248275
            // this will be valid in case the sticko parent element has class 'sticko-on-largeHeight'
            var hHeight = sticko.get.fixedpageElementsHeight();
            var chHeights = 0;
            UX.sticko.$child.children().each(function () {
                chHeights += $(this).outerHeight();
            });
            if (sticko.$parent.hasClass('sticko-on-largeHeight') && $(window).outerHeight() - hHeight < chHeights) {
                sticko.$parent.attr('style', '');
                sticko.$element.removeClass('js--sticko').attr('style', '');
                sticko.$child.attr('style', '');
            }
            return sticko.$parent.hasClass('sticko-on-largeHeight') && $(window).outerHeight() - hHeight < chHeights;
        },
    };

    /**
     * @deprecated
     */
    UX.sticko = sticko; // add to global namespace
})();
